import { render, staticRenderFns } from "./CommentAction.vue?vue&type=template&id=d29abd48&scoped=true"
import script from "./CommentAction.vue?vue&type=script&lang=js"
export * from "./CommentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29abd48",
  null
  
)

export default component.exports